module.exports = __webpack_public_path__ + "media/images/icon-card/icon-card-08-536de8e396be90001a3932ebc1fe5254.svg";